import styled from 'styled-components';
import { blackSphera, greenSp } from 'src/utilities/UIStyles/variables/Colors';

export const Eventswebinars = styled.section`
  > h3 {
    color: ${blackSphera};
    font-size: 2.5vw;
    width: 70%;
    margin: 2% 15%;
    text-align: center;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
  }
  > h4 {
    color: ${blackSphera};
    font-size: 1.7vw;
    font-weight: normal;
    width: 70%;
    margin: 2% 15%;
    text-align: center;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
  }
`;

export const EventsWebinarsTitle = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > div {
    margin: 7% 2% 2% 5%;
    padding: 2%;
    width: 40%;
    > h2 {
      color: ${blackSphera};
      font-size: 3.5vw;
      width: 100%;
      > span {
        color: ${greenSp};
        font-size: 3.5vw;
      }
    }
    > h3 {
      color: ${blackSphera};
      font-size: 2.8vw;
      width: 100%;
    }
    > p {
      color: ${blackSphera};
      font-size: 1.3vw;
      width: 80%;
    }
    > img {
      width: 50%;
      height: auto;
      background-size: cover;
      top: 0;
      right: 0;
      position: absolute;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    padding-top: 25%;
    > div {
      width: 100%;
      > h2 {
        font-size: 6vw;
        width: 100%;
        > span {
          font-size: 6vw;
        }
      }
      > p {
        font-size: 3.5vw;
        width: 50%;
      }
    }
  }
`;

export const EventsWebinarFigure = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 5% 0;
  width: 90%;
  margin: 5% 5% 0 5%;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const EventsCard = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin: auto;
  /* background-color: orange; */
`;
export const Card = styled.div`
  width: 30%;
  -webkit-box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  > figure {
    width: 100%;
    height: auto;
    border-radius: 20px;
    padding-top: 5%;

    > img {
      width: 100%;
    }
  }
  > figure:nth-child(2) {
    border-top: 2px solid #148043;
    > img {
    }
  }

  > p {
    text-align: center;
    font-size: 1.2vw;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const CardFooter = styled.div`
  /* background-color: salmon; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  flex-direction: 'row';
  padding-bottom: 4%;

  > div {
    display: flex;
    flex-wrap: wrap;
    flex-direction: 'row';
    width: 30%;
    > figure {
      width: 30px;
      height: 30px;
      margin: 1% 3%;
      > img {
        width: 100%;
        height: auto;
      }
    }
    > p {
      width: 50%;
      color: #148043;
      font-size: 1vw;
    }
    > h4 {
      width: 80%;
      color: #148043;
      font-size: 1vw;
    }
  }
  > figure {
    width: 30%;
    height: 30%;
    > img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const CompoundInterestConstancy = styled.section`
  /* background-color: ${greenSp}; */
  padding-bottom: 5%;
  > h2 {
    width: 50%;
    margin: auto;
    padding: 2% 0 1% 0;
    text-align: center;
    font-size: 2.5vw;
    color: ${blackSphera};
  }
  > p {
    text-align: center;
    padding-bottom: 2%;
    font-size: 1.1vw;
    color: ${blackSphera};
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      width: 70%;
      font-size: 3vw;
    }
    > p {
      font-size: 2vw;
    }
  }
  @media (max-width: 600px) {
    padding-bottom: 5%;
    > h2 {
      width: 90%;
      padding: 5% 0 1% 0;
      font-size: 6vw;
    }
    > p {
      font-size: 3vw;
      margin-bottom: 3%;
    }
  }
`;

export const SuperPowerCards = styled.section`
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: auto;
  > div:nth-child(1),
  > div:nth-child(2),
  > div:nth-child(3) {
    width: 25%;
    padding: 3% 0 2.5% 0;
    background-color: ${blackSphera};
    border-radius: 5px;
    > h5 {
      text-align: center;
      font-size: 1.2vw;
      color: white;
    }
    > p {
      width: 75%;
      margin: 7% auto auto auto;
      text-align: center;
      font-size: 1.2vw;
      color: white;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1),
    > div:nth-child(2),
    > div:nth-child(3) {
      > h5 {
        font-size: 1.5vw;
      }
      > p {
        font-size: 1.3vw;
      }
    }
  }

  @media (max-width: 600px) {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 80%;
    > div:nth-child(1),
    > div:nth-child(2),
    > div:nth-child(3) {
      width: 100%;
      height: 170px;
      margin-bottom: 5%;
      > h5 {
        font-size: 5vw;
      }
      > p {
        width: 80%;
        font-size: 3.2vw;
      }
    }
  }
`;
